module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_von_Kesswil-b9dbb1dac702bbdf220f86410aea64df.gif";